export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14522.947a74cc.jpg";